import React from 'react';
import { RECEPTION_PERIODS, STATUS_FILTERS } from './receptionPeriods';

export default function ReceptionPeriodFilters({
  period,
  onPeriod,
  statusFilter,
  onStatus,
  brand = '#F15A22',
}) {
  return (
    <div className="space-y-3" data-testid="reception-period-filters">
      <div className="flex flex-wrap gap-1.5">
        {RECEPTION_PERIODS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => onPeriod(p.key)}
            className={`px-3.5 py-2 rounded-lg text-xs font-semibold transition ${
              period === p.key
                ? 'text-white shadow-md'
                : 'bg-white text-[#071B34] border border-[#D5DEE8] hover:bg-[#E8EEF5]'
            }`}
            style={period === p.key ? { background: brand } : undefined}
            data-testid={`period-${p.key}`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {STATUS_FILTERS.map((f) => (
          <button
            key={f.key}
            type="button"
            onClick={() => onStatus(f.key)}
            className={`px-2.5 py-1 rounded-full text-[10px] uppercase tracking-wider font-bold border transition ${
              statusFilter === f.key
                ? 'text-white border-transparent'
                : 'text-[#5A6B7C] border-[#D5DEE8] bg-white/80'
            }`}
            style={statusFilter === f.key ? { background: '#071B34' } : undefined}
            data-testid={`status-filter-${f.key}`}
          >
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}
